import { AspectRatio, AspectRatioProps, Image } from "@chakra-ui/react";
import { filestoreUrl } from "config";
import { ImageSize } from "types";

export type TraitImageProps = Omit<AspectRatioProps, "ratio" | "color"> & {
  tokenId: number;
  furColor: number;
  postfix?: string;
  size?: ImageSize;
  isDisabled?: boolean;
};

const TraitImage = ({
  tokenId,
  furColor,
  postfix,
  size = "512",
  isDisabled = false,
  ...rest
}: TraitImageProps) => {
  const src = `${filestoreUrl}/elements/${tokenId}_${furColor}_${size}${
    postfix ? "_" + postfix : ""
  }.png`;

  return tokenId !== 0 ? (
    <AspectRatio ratio={1} w="full" {...rest}>
      <Image
        src={src}
        fit="cover"
        transition="opacity 0.15s"
        alt={`${tokenId}`}
      />
    </AspectRatio>
  ) : null;
};

export default TraitImage;
